import React from "react";
import "../styles/product-skeleton.css";

const ProductSkeleton = () => {
  return (
    <div className="product-skeleton">
      <div className="skeleton-image" />
      <div className="skeleton-info">
        <div className="skeleton-line skeleton-name-1" />
        <div className="skeleton-line skeleton-name-2" />
        <div className="skeleton-line skeleton-brand" />
      </div>
    </div>
  );
};

const ProductSkeletonGrid = ({ count = 9 }) => {
  return (
    <div className="products-grid">
      {Array.from({ length: count }).map((_, i) => (
        <ProductSkeleton key={i} />
      ))}
    </div>
  );
};

export default ProductSkeletonGrid;
